import styled from 'styled-components'

import ActionButton from '../ActionButton'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2.3rem;
`

export const Button = styled(ActionButton)``
